import Big from 'big.js';
import { calcularPorcentagemDeValor, calcularValorDePorcentagem } from '@/utils/calculations';

const SCALE = 4;
const ROUND = Big.roundHalfUp;

const toBig = value => new Big(value == null || value === '' ? 0 : value);

export const roundProposalAmount = value => Number(toBig(value).round(SCALE, ROUND));

export const totalFromUnit = (valorUnitario, quantidade) =>
  Number(toBig(valorUnitario).times(toBig(quantidade)).round(SCALE, ROUND));

export const unitFromDiscount = (referencia, percentual) =>
  roundProposalAmount(calcularValorDePorcentagem(Number(referencia || 0), Number(percentual || 0)));

export const amountsFromUnit = (valorUnitario, quantidade) => ({
  valorUnitario: roundProposalAmount(valorUnitario),
  valorTotal: totalFromUnit(valorUnitario, quantidade),
});

export const discountPercentFromRanking = (referenciaTotal, rankingValor) => {
  const total = toBig(referenciaTotal);
  if (total.eq(0)) return 0;
  const desconto = total.minus(toBig(rankingValor));
  return Number(calcularPorcentagemDeValor(Number(total), Number(desconto)));
};

export const resolveUnitInput = (proposal, tipoNegociacaoId) => {
  if (!proposal) return null;
  const persistedUnit =
    proposal.valorUnitario != null ? proposal.valorUnitario : proposal.valor_unitario;
  if (persistedUnit != null && persistedUnit !== '') {
    return Number(persistedUnit);
  }
  if (tipoNegociacaoId === 1 && proposal.valor != null && proposal.valor !== '') {
    return Number(proposal.valor);
  }
  return null;
};

export const reconcileLotAmounts = (items, targetTotal) => {
  if (!items.length) {
    return { items: [], valorTotal: 0 };
  }

  const roundedItems = items.map(item => ({
    quantidade: Number(item.quantidade),
    ...amountsFromUnit(item.valorUnitario, item.quantidade),
  }));

  const roundedSum = roundedItems.reduce((acc, item) => acc.plus(item.valorTotal), new Big(0));

  const unroundedSum = items.reduce(
    (acc, item) => acc.plus(toBig(item.valorUnitario).times(toBig(item.quantidade))),
    new Big(0),
  );

  const target =
    targetTotal == null || targetTotal === ''
      ? unroundedSum.round(SCALE, ROUND)
      : toBig(roundProposalAmount(targetTotal));

  const diff = target.minus(roundedSum.round(SCALE, ROUND));

  if (!diff.eq(0)) {
    const last = roundedItems[roundedItems.length - 1];
    last.valorTotal = Number(toBig(last.valorTotal).plus(diff).round(SCALE, ROUND));
  }

  const valorTotal = Number(
    roundedItems.reduce((acc, item) => acc.plus(item.valorTotal), new Big(0)).round(SCALE, ROUND),
  );

  return { items: roundedItems, valorTotal };
};
